import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { DataGrid } from '@mui/x-data-grid';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, IconButton } from '@mui/material';
import { Close, FileDownload, LocationOn } from '@mui/icons-material';
import { DirectionsRenderer, DirectionsService, GoogleMap, LoadScript, Marker, Polyline } from '@react-google-maps/api';
import api from '../config/backend';
import './css/Attendance.css';
import { useParams } from 'react-router-dom';
import DownloadExportData from '../utils/excel';

function AttendenceData() {
    // Format today's date as YYYY-MM-DD for the date picker
    const pad = (n) => n.toString().padStart(2, '0');
    const today = new Date();
    const todayFormatted = `${today.getFullYear()}-${pad(today.getMonth() + 1)}-${pad(today.getDate())}`;
    const { status } = useParams();
    const [date, setDate] = useState(todayFormatted);
    const [rows, setRows] = useState([]);
    const token = localStorage.getItem("_crm__token");
    const [downloading, setDownloading] = useState(false);
    const columns = [
        { field: 'id', headerName: 'ID', width: 70 },
        { field: 'Employee_code', headerName: 'Employee Code', width: 130 },
        { field: 'employeeName', headerName: 'Employee Name', width: 200 },
        { field: 'email', headerName: 'Email', width: 250 },
        { field: 'Date', headerName: 'Date', width: 120 },
        { field: 'Designation', headerName: 'Designation', width: 180 },
    ];

    const fetchAttendance = async (status) => {
        try {
            const response = await axios.post(`${api}/Dashboard/absent-employees`, {
                token,
                date,
                type: status,
            });

            if (response.data.success) {
                // Process attendance data
                const attendanceData = response.data.data;
                const formattedRows = [];

                // For each attendance record, fetch employee details
                for (let i = 0; i < attendanceData.length; i++) {
                    const attendance = attendanceData[i];

                    formattedRows.push({
                        id: i + 1,
                        Employee_code: attendance?.Employee_code || '-',
                        employeeName: attendance?.firstName + attendance?.lastName || 'Unknown',
                        email: attendance?.company_email || 'Unknown',
                        Date: new Date(date).toLocaleDateString() || '-',
                        Designation: attendance?.Designation || '-',
                        data: attendance,
                        // Add any other fields you need
                    });
                }

                setRows(formattedRows);
            }
        } catch (error) {
            console.error('Error fetching attendance data:', error);
        }
    };

    useEffect(() => {
        fetchAttendance(status);
    }, [date, status]);

    const handleDateChange = (e) => {
        setDate(e.target.value);
    };
    const handleDownloadExcel = async () => {
        setDownloading(true);
        try {
            const response = await axios.post(`${api}/Dashboard/absent-employees`,
                {
                    token,
                    date,
                    type: status,
                    download: true
                },
                {
                    responseType: 'blob', // Important for file downloads
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                }
            );

            DownloadExportData(response.data, 'Employee.csv');

        } catch (error) {
            console.error('Error downloading Excel file:', error);
            alert('Failed to download Excel file');
        } finally {
            setDownloading(false);
        }
    };

    return (
        <div className="app-table-container">
            <div className="employee-header">
                <h2>Employee Attendance ({status})</h2>
                <div className='Header_div'>
                    <Button
                        variant="outlined"
                        startIcon={<FileDownload />}
                        onClick={handleDownloadExcel}
                        // className="download-excel-btn"
                        disabled={downloading}
                    >
                        {downloading ? 'Downloading...' : 'Export to Excel'}
                    </Button>
                    <div className="date-picker-container">
                        <label>Select Date: </label>
                        <input
                            type="date"
                            value={date}
                            onChange={handleDateChange}
                            className="date-picker"
                        />
                    </div>
                </div>
            </div>
            <div className="app-table">
                <DataGrid
                    rows={rows}
                    columns={columns}
                    initialState={{
                        pagination: {
                            paginationModel: { page: 0, pageSize: 10 },
                        },
                    }}
                    pageSizeOptions={[5, 10, 20]}
                />
            </div>
        </div>
    );
}

export default AttendenceData;
